import "./Prices.module.css";
import Header from "@/reusable_sections/Header";
import ChooseYourPace from "./sections/ChooseYourPace";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PricesPage() {
  return <div>
      <Header />
      <ChooseYourPace />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}